<script setup lang="ts">
import AuthLayout from '@/layouts/AuthLayout.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLock } from '@fortawesome/free-solid-svg-icons'

library.add(faLock)
</script>

<template>
  <AuthLayout>
    <template #header>
      <div class="text-center">
        <h1 class="text-3xl font-bold text-gray-900">Registration Disabled</h1>
        <p class="mt-2 text-gray-600">
          Self-registration is currently unavailable.
        </p>
      </div>
    </template>

    <div class="mt-8 max-w-md mx-auto">
      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center">
        <div class="w-16 h-16 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <FontAwesomeIcon icon="lock" class="h-8 w-8" />
        </div>
        
        <h2 class="text-xl font-bold text-gray-900 mb-2">Account Creation Restricted</h2>
        <p class="text-gray-600 text-sm mb-6">
          Public registration has been disabled by the system administrator. If you require an account, please contact your organization administrator or supervisor.
        </p>

        <div class="space-y-3">
          <RouterLink
            to="/login"
            class="w-full flex justify-center items-center py-3 px-4 rounded-xl bg-green-600 hover:bg-green-700 text-white font-bold text-base transition-colors shadow-sm"
          >
            Return to Sign In
          </RouterLink>
          
          <RouterLink
            to="/contact"
            class="w-full flex justify-center items-center py-3 px-4 rounded-xl border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium text-sm transition-colors"
          >
            Contact Support
          </RouterLink>
        </div>
      </div>
    </div>
  </AuthLayout>
</template>
